import React from "react";
import { useContext } from "react";
import { AppContext } from "../AppContextProvider";
import { makeStyles, Grid, Paper, Table, TablePagination, TableRow, TableBody, Typography, Divider, Icon, Tooltip, IconButton } from "@material-ui/core";
import { blue, red } from "@material-ui/core/colors";
import { TABLE_COUNTS } from "../Constants";
import { RowCountOptions } from "../Config";
import EnhancedTableHead from "../components/EnhancedTableHead";
import { toInt, StyledTableCell, getTimeInIST, format_display_fancy_notime, format_fancy, BootstrapTooltip } from "../Utils";
import moment from "moment";
import SingleDate from "../components/SingleDate";
import SearchBar from "../components/SearchBar";
import ItemSelection from "../components/ItemSelection";
import { ProductService } from "../Services/ProductService";

const useStyles = makeStyles(theme => ({
    section: {
        width: '100%',
        height: '100%',
        marginTop: theme.spacing(1),
        paddingTop : theme.spacing(1),
        paddingBottom: theme.spacing(1)
    },
    qtyField: {
        width: "40%",
        position: "relative",
        [theme.breakpoints.up('md')]: {
            right: '100px',
            width: "10%",
            marginRight: 10
        },
        right: "22px"
    },
    searchBar: {
        maxWidth: 180,
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom : '20px',
    },
    grid: {
        [theme.breakpoints.up('md')]: {
            marginTop: '10px',
        },
        marginTop: '50px',
        marginBottom: '5px'
    },
    icon: {
        padding: '0px',
        [theme.breakpoints.up('md')]: {
            padding: '12px',
        },
    },
    tablecell: {
        fontSize: '16pt',
        padding: theme.spacing(4)
    },
    container: {
        paddingTop : theme.spacing(1)
    },
    redAvatar: {
        margin: 10,
        color: '#fff',
        backgroundColor: red[500],
    },
    blueAvatar: {
        margin: 10,
        color: '#fff',
        backgroundColor: blue[500],
    },
    instructions: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(3),
        marginBottom: theme.spacing(1),
    },
    button: {
        marginTop: theme.spacing(1),
        // height: theme.spacing(7),
        float: 'right',
        marginLeft: theme.spacing(2),
        [theme.breakpoints.down('md')]: {
            float: 'inherit',
            marginLeft: theme.spacing(1)
        },
        marginRight: theme.spacing(4),
        
    }, 
    tableWrapper: {
        maxHeight: 407,
        overflow: 'auto',
    },
    list: {
        width: '100%',
        height: 250,
        overflow: "auto"
    },
    summary: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    title: {
        fontSize: 18,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    subtitle: {
        fontSize:18,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    selectRoot: {
        fontSize: 12,
        [theme.breakpoints.down('md')]: {
            marginLeft: 0,
            marginRight: 0
        },
    },
}));

export default function QRScanPage(props){

    const {setTitle, setLinearLoading, showProgressDialog, closeProgressDialog, sourceTypes, showSnackBar} = useContext(AppContext);
    const classes = useStyles();
    const [selectedSources, setSelectedSources] = React.useState([]);
    const [selectedProduct, setSelectedProduct] = React.useState(null);
    const [products, setProducts] = React.useState([]);
    const [filter, setFilter] = React.useState('');
    const [startdate, setStartDate] = React.useState(moment().startOf('day').startOf('month'));
    const [enddate, setEndDate] = React.useState(moment().endOf('day'));
    const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = React.useState('created_date');
    const [data, setData] = React.useState([]);
    const [generate, setGenerate] = React.useState(true);
    const [loadedMaster, setLoadedMaster] = React.useState(false);
    const [initialLoading, setInitialLoading] = React.useState(true);
    const columns = [
        { id: 'index', align: 'left', numeric: false, disablePadding: false, label: 'Sl.No.', sortable: false },
        { id: 'customer', align: 'center', numeric: false, disablePadding: true, label: 'Customer', sortable: false },
        { id: 'mobile', align: 'center', numeric: false, disablePadding: true, label: 'Mobile', sortable: false },
        { id: 'dob', align: 'center', numeric: false, disablePadding: true, label: 'DOB', sortable: false },
        { id: 'address', align: 'center', numeric: false, disablePadding: true, label: 'Address', sortable: false },
        { id: 'source', align: 'center', numeric: true, disablePadding: true, label: 'Source', sortable: true },
        { id: 'url', align: 'justify', numeric: false, disablePadding: false, label: 'URL', sortable: false },
        { id: 'scan_date', align: 'center', numeric: false, disablePadding: true, label: 'Scanned On', sortable: true },
        // { id: 'action', align: 'right', numeric: true, disablePadding: false, label: '', sortable: false },
    ];

    //Pagination
    const [totalItems, setTotalItems] = React.useState(0);
    const [numItemsPerPage, setNumItemsPerPage] = React.useState(localStorage.getItem(TABLE_COUNTS.orders_tab_count) ? toInt(localStorage.getItem(TABLE_COUNTS.orders_tab_count)) : RowCountOptions[0]);
    const [currentPageNumber, setCurrentPageNumber] = React.useState(0);
    const [fetchPage, setFetchPage] = React.useState(false);

    const handleChangeRowsPerPage = event => {
        setNumItemsPerPage(event.target.value);
        setCurrentPageNumber(0);
        setFetchPage(true);
        localStorage.setItem(TABLE_COUNTS.orders_tab_count, event.target.value);
    }

    const saveProductPref = (id) => {
        localStorage.setItem('eauthenticity.product_pref', id);
    }

    const handleChangePage = (event, page) => {
        if(currentPageNumber > page){
            fetchRow(currentPageNumber - 1);
        } else {
            fetchRow(currentPageNumber + 1);
        }
    };

    const fetchRow = (newCurrentPage) => {
        setCurrentPageNumber(newCurrentPage);
        setFetchPage(true);
    }

    React.useEffect(() => {
        setTitle('View QR Scans');
        let pref = localStorage.getItem("eauthenticity.product_pref");
        ProductService.getProductsCount('', '0,1')
        .then(data => {
            let count = toInt(data.count);
            ProductService.getProducts('', 'name', 'asc', '0,1', 0, count)
            .then(data => {
                if(data.length > 0){
                    setProducts(data)
                    if(pref){
                        let p = data.find(p => p.id === pref);
                        if(p){
                            setSelectedProduct(p)
                        } else {
                            setSelectedProduct(data[0])
                        }
                    }
                }
                setLoadedMaster(true);
            })
           
        })
        return () => {
            setTitle('');
        }
    }, [true]);

    // React.useEffect(() => {
    //     if(loadedMaster){
    //         closeProgressDialog();
    //     }
    // }, [loadedMaster]);

    React.useEffect(() => {
        if(generate && loadedMaster && selectedProduct){
            showProgressDialog();
            setLinearLoading(true);
            if(initialLoading){
                setData([]);
                setCurrentPageNumber(0);
                setInitialLoading(false);
            }
            let selectedSource = selectedSources && selectedSources.length > 0 ? selectedSources.map(s => s.key).join(',') : null;
            let selectedProductId = selectedProduct ? selectedProduct.id : null;
            let fc = filter && filter.length > 0 ? filter : '';
            ProductService.getProductQRScansCount(selectedProductId, fc, null, selectedSource, 1, startdate, enddate)
            .then(data => {
                console.log(data);
                setTotalItems(toInt(data.count));
                if(toInt(data.count) === 0){
                    setData([]);
                    closeProgressDialog()
                } else {
                    setFetchPage(true);
                }
                setLinearLoading(false);
            })
            .catch(error => {
                console.log(error);
                setLinearLoading(false);
            });
            setGenerate(false);
        }
    }, [generate, loadedMaster, selectedProduct]);

    React.useEffect(() => {
        if(fetchPage) {
            setLinearLoading(true);
            let selectedSource = selectedSources && selectedSources.length > 0 ? selectedSources.map(s => s.key).join(',') : null;
            let selectedProductId = selectedProduct ? selectedProduct.id : null;
            let fc = filter && filter.length > 0 ? filter : '';
            ProductService.getProductQRScans(selectedProductId, fc, null, selectedSource, 1, startdate, enddate, orderBy, order, currentPageNumber * numItemsPerPage, numItemsPerPage)
            .then((data) => {
                console.log(data);
                setData(data || []);
                setLinearLoading(false);
                closeProgressDialog();
            })
            .catch(error => {
                console.log(error);
                setLinearLoading(false);
                closeProgressDialog();
            });
        }
        setFetchPage(false);
    }, [fetchPage]);

    const sortBy = (event, property) => {
        let o = 'desc';
        if (orderBy === property && order === 'desc') {
            o = 'asc';
        }
        setOrder(o);
        setOrderBy(property);
        setGenerate(true);
    }

    const exportData = () => {
        setLinearLoading(true);
        let selectedSource = selectedSources && selectedSources.length > 0 ? selectedSources.map(s => s.key).join(',') : null;
        let selectedProductId = selectedProduct ? selectedProduct.id : null;
        let fc = filter && filter.length > 0 ? filter : '';
        ProductService.getProductQRScansExport(selectedProductId, fc, null, selectedSource, 1, startdate, enddate, orderBy, order, currentPageNumber * numItemsPerPage, numItemsPerPage)
        .then((blob) => {
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'QR Scans.xlsx');
            // 3. Append to html page
            document.body.appendChild(link);
            // 4. Force download
            link.click();
            // 5. Clean up and remove the link
            link.parentNode.removeChild(link);
        })
        .catch(error => {
            showSnackBar('Something went wrong. Please try again', 'error')
        })
        .finally(() => {
            setLinearLoading(false);
        })
    }


    return (
        <div className="Home">
            <div className="lander">
                <Grid container direction="row" spacing={1} justify="center">
                    <Grid item xl={11} lg={12} xs={12}>
                        <Paper className={classes.section}>
                            <Grid container spacin={1} alignItems="center">
                                <Grid item xs={12} lg={2}>
                                    <ItemSelection 
                                        clearable={false} 
                                        label='Product' 
                                        value={selectedProduct || null} 
                                        optionLabel='name' 
                                        options={products} 
                                        selected={(p) => {
                                            saveProductPref(p.id)
                                            setSelectedProduct(p)
                                            setGenerate(true)
                                        }}/>
                                </Grid>
                                <Grid item xs={12} lg={2}>
                                    <ItemSelection 
                                        multiple 
                                        clearable={true} 
                                        label='Sources' 
                                        value={selectedSources} 
                                        optionLabel='label' 
                                        options={sourceTypes} 
                                        selected={setSelectedSources}/>
                                </Grid>
                                <Grid item>
                                    <div style={{maxWidth: 170}}>
                                        <SingleDate 
                                            label="From"
                                            date={startdate}
                                            maxDate={moment()}
                                            setDate={(date) => {
                                                setStartDate(date);
                                            }}
                                            onKeyUp={(event) => {
                                                event.preventDefault();
                                                if (event.key === 'Enter'){
                                                    !generate && setGenerate(true)
                                                }
                                            }}/>
                                    </div>
                                </Grid>
                                <Grid item>
                                    <div style={{maxWidth: 170, marginLeft: 8}}>
                                        <SingleDate 
                                            label="To"
                                            date={enddate}
                                            minDate={startdate}
                                            maxDate={moment()}
                                            setDate={(date) => {
                                                setEndDate(date);
                                            }}
                                            onKeyUp={(event) => {
                                                event.preventDefault();
                                                if (event.key === 'Enter'){
                                                    !generate && setGenerate(true)
                                                }
                                            }}/>
                                    </div>
                                </Grid>
                                <Grid item xs={12} lg={4}>
                                        {
                                            loadedMaster && (
                                                <div style={{float: 'right', marginTop: 8, marginRight: 8}}>
                                                    <SearchBar 
                                                        className={classes.searchBar}
                                                        hint="Search..."
                                                        searchText={filter}
                                                        onTextChange={(e) => {
                                                        setFilter(e.target.value);
                                                        setGenerate(true);
                                                    }}/>
                                                </div>
                                            )
                                        }
                                </Grid>
                                <Grid item>
                                    <Tooltip title="Refresh">
                                        <IconButton size="medium" style={{marginTop: 8}} aria-label="Refresh" color="primary" onClick={() => {!generate && setGenerate(true)}}>
                                            <Icon>refresh</Icon>
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                                <Grid item>
                                    <BootstrapTooltip arrow title={totalItems === 0 ? "" : "Download"}>
                                        <IconButton size="medium" disabled={totalItems === 0} style={{marginTop: 8}} aria-label="Refresh" color="inherit" onClick={exportData}>
                                            <Icon>save_alt</Icon>
                                        </IconButton>
                                    </BootstrapTooltip>
                                </Grid>
                                <Grid item xs={12} lg={12}>
                                    <Divider style={{marginBottom: 0, marginTop: 10}}/>
                                </Grid>
                                <Grid item xs={12} lg={12}>
                                    <div style={{minHeight: 100, overflowY: 'auto', display: 'block'}}>
                                        <Table className={classes.table} stickyHeader>
                                            <EnhancedTableHead
                                                order={order}
                                                orderBy={orderBy}
                                                onRequestSort={sortBy}
                                                rows={columns} />
                                            <TableBody>
                                                {
                                                    data && data.map((element, index) => {
                                                        return (
                                                            <TableRow 
                                                                key={index} 
                                                                hover
                                                                style={{cursor: 'pointer'}} >
                                                                <StyledTableCell scope="row" align="center" padding='none' style={{width: 20}}>
                                                                    {index + 1 + (currentPageNumber * numItemsPerPage)}
                                                                </StyledTableCell>
                                                                <StyledTableCell scope="row" align="justify" padding='none'>
                                                                    {element.name || ''}
                                                                </StyledTableCell>
                                                                <StyledTableCell scope="row" align="justify" padding='none'>
                                                                    {element.mobile || ''}
                                                                </StyledTableCell>
                                                                <StyledTableCell scope="row" align="center" padding='none'>
                                                                    {element.dob ? moment(element.dob).format(format_display_fancy_notime) : '-'}
                                                                </StyledTableCell>
                                                                <StyledTableCell scope="row" align="right" padding='none' style={{paddingRight: 16}}>
                                                                    {element.address1 ? (element.address1 + ', ' + (element.address2 ? element.address2 : '') + ', ' + (element.address3 ? element.address3 : '') + ', ' + (element.state ? element.state : '') + ', ' + element.pincode) : '-'}
                                                                </StyledTableCell>
                                                                <StyledTableCell scope="row" align="center" padding='none'>
                                                                    {element.source}
                                                                </StyledTableCell>
                                                                <StyledTableCell scope="row" align="center" padding='none' style={{paddingRight: 16}}>
                                                                    <BootstrapTooltip title={element.url}>
                                                                        <div>
                                                                            <span>{`${element.url.substring(0, 125)}${element.url.length > 125 ? '...' : ''}`}</span>
                                                                        </div>
                                                                    </BootstrapTooltip>
                                                                </StyledTableCell>
                                                                <StyledTableCell scope="row" align="center" padding='none'>
                                                                    {element.scan_date ? getTimeInIST(element.scan_date).format(format_fancy) : '-'}
                                                                </StyledTableCell>
                                                            </TableRow>
                                                        )
                                                    }
                                                )}
                                            </TableBody>
                                        </Table>
                                    </div>
                                    {
                                        totalItems === 0 && 
                                            <Typography color="error" variant="subtitle2">No Scans</Typography>
                                    }
                                    <TablePagination
                                        rowsPerPageOptions={RowCountOptions}
                                        component="div"
                                        count={totalItems}
                                        rowsPerPage={numItemsPerPage}
                                        page={currentPageNumber}
                                        backIconButtonProps={{
                                            'aria-label': 'Previous Page',
                                        }}
                                        nextIconButtonProps={{
                                            'aria-label': 'Next Page',
                                        }}
                                        onChangePage={handleChangePage}
                                        onChangeRowsPerPage={handleChangeRowsPerPage}
                                        classes={{ selectRoot : classes.selectRoot}}/>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </div>
    )
}